/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetInvestingMetricsRequest} from '@cash-web/protos/squareup/cash/marketdata/server/investment_metrics_service.pb'
import {GetInvestingMetricsResponse} from '@cash-web/protos/squareup/cash/marketdata/server/investment_metrics_service.pb'


export const getInvestingMetrics = (request: GetInvestingMetricsRequest, options?: CashRequestOptions) => post<GetInvestingMetricsRequest, GetInvestingMetricsResponse>("/cash-app/investing/get-investing-metrics", request, {...options, rejectOnError: true })